(function() {
    // 1. ВРЪЩАМЕ ЗЛАТНИТЕ СТИЛОВЕ ЗА БАНЕРА (ЗАПАЗЕНИ НА 100%)
    const style = document.createElement('style');
    style.innerHTML = `
        #magoo-bundle-banner {
            width: 100%;
            background: linear-gradient(90deg, #d4a000 0%, #FFC107 25%, #ffe082 50%, #FFC107 75%, #d4a000 100%);
            background-size: 200% auto;
            color: #1a1a1a;
            text-align: center;
            overflow: hidden;
            max-height: 0;
            opacity: 0;
            display: none;
            transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
            z-index: 9999;
        }
        #magoo-bundle-banner.is-active {
            display: flex;
            max-height: 100px;
            opacity: 1;
            padding: 12px 0;
            animation: gold-shimmer 15s linear infinite;
            align-items: center;
            justify-content: center;
        }
        @keyframes gold-shimmer { 0% { background-position: 0% 50%; } 100% { background-position: 200% 50%; } }
    `;
    document.head.appendChild(style);

    window.MagooBundle = {
        // Стойности по подразбиране (Fallback), ако Хъбът не отговори
        settings: { level1: 1, level2: 3 },

        init: async function() {
            // Първо зареждаме настройките от твоя нов JSON файл
            await this.loadSettings();
            this.checkCart();
            this.setupEventListeners();
        },

        // НОВАТА ВРЪЗКА: Проверяваме какво е записал Хъбът в bundle_config.json
        loadSettings: async function() {
            try {
                const response = await fetch('https://hub.magoo.bg/core/bundle_config.json?v=' + Date.now(), { cache: "no-cache" });
                if (response.ok) {
                    const data = await response.json();
                    this.settings.level1 = parseFloat(data.level1) || 1;
                    this.settings.level2 = parseFloat(data.level2) || 3;
                }
            } catch (e) {
                console.warn("Magoo Engine: Използвам вградени настройки (1% и 3%).");
            }
        },

        checkCart: async function() {
            try {
                const res = await fetch(`${window.Shopify.routes.root}cart.js?t=${Date.now()}`);
                const cart = await res.json();
                
                let premiumCount = 0;
                let premiumTotal = 0;

                const promises = cart.items.map(item => 
                    fetch(`${window.Shopify.routes.root}products/${item.handle}.js`)
                        .then(r => r.json())
                        .then(p => {
                            if (p.tags && p.tags.some(t => t.toLowerCase().trim() === 'premium')) {
                                premiumCount += item.quantity;
                                premiumTotal += item.original_line_price;
                            }
                        })
                );

                await Promise.all(promises);
                this.updateBothUIs(premiumCount, premiumTotal);
            } catch (e) { console.error("Magoo Engine Error:", e); }
        },

        updateBothUIs: function(pCount, pTotal) {
            const banner = document.getElementById('magoo-bundle-banner');
            const bannerText = document.getElementById('bundle-message-text');
            const liquidNudgeContainer = document.getElementById('magoo-liquid-nudge');
            
            if (pCount === 0) {
                if (banner) { banner.style.display = 'none'; banner.classList.remove('is-active'); }
                if (liquidNudgeContainer) liquidNudgeContainer.style.display = 'none';
                return;
            }

            let message = "";
            let savingsRaw = (pTotal / 100);

            // ВЗИМАМЕ ПРОЦЕНТИТЕ ДИНАМИЧНО ОТ ХЪБА
            const L1 = this.settings.level1; 
            const L2 = this.settings.level2;

            if (pCount === 1) {
                message = `💎 ПРЕМИУМ ПРОДУКТ: Добави още 1 и спести ${L1}%!`;
            } else if (pCount === 2) {
                const saved = (savingsRaw * (L1 / 100)).toFixed(2);
                message = `✅ СПЕСТЯВАТЕ ${L1}% (-${saved} €) | ДОБАВИ ОЩЕ ЕДИН ПРЕМИУМ ЗА ${L2}%!`; 
            } else if (pCount >= 3) {
                const saved = (savingsRaw * (L2 / 100)).toFixed(2);
                message = `🚀 ПОЗДРАВЛЕНИЯ! СПЕСТИХТЕ ${L2}% (-${saved}€)!`;
            }

            if (banner && bannerText) {
                bannerText.innerHTML = message;
                banner.style.setProperty('display', 'flex', 'important');
                banner.classList.add('is-active');
            }

            if (liquidNudgeContainer) {
                const textDiv = liquidNudgeContainer.querySelector('div');
                if (textDiv) textDiv.innerHTML = message;
                liquidNudgeContainer.style.display = 'block';
            }
        },

        setupEventListeners: function() {
            document.addEventListener('cart:updated', () => this.checkCart());
            const oldFetch = window.fetch;
            window.fetch = function() {
                return oldFetch.apply(this, arguments).then(res => {
                    if (res.url.includes('/cart/')) {
                        setTimeout(() => window.MagooBundle.checkCart(), 500);
                    }
                    return res;
                });
            };
        }
    };

    window.MagooBundle.init();
})();